"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Twilio = require("twilio-chat");
var ChatSend = function (props) {
    var chatToken = props.chatToken, channelId = props.channelId, threadId = props.threadId;
    var _a = react_1.default.useState(null), channel = _a[0], setChannel = _a[1];
    var _b = react_1.default.useState(null), message = _b[0], setMessage = _b[1];
    react_1.default.useEffect(function () {
        var fn = function () { return __awaiter(void 0, void 0, void 0, function () {
            var client, ch, _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, Twilio.Client.create(chatToken)];
                    case 1:
                        client = _b.sent();
                        return [4, client.getChannelBySid(channelId)];
                    case 2:
                        ch = _b.sent();
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 6, , 7]);
                        _a = ch.join;
                        if (!_a) return [3, 5];
                        return [4, ch.join()];
                    case 4:
                        _a = (_b.sent());
                        _b.label = 5;
                    case 5:
                        _a;
                        return [3, 7];
                    case 6:
                        e_1 = _b.sent();
                        return [3, 7];
                    case 7:
                        setChannel(function () { return setChannel(ch); });
                        return [2];
                }
            });
        }); };
        fn();
    }, [chatToken]);
    var handleChange = function (e) { return setMessage(function () { return e.target.value; }); };
    var handleSubmit = function (e) {
        e.preventDefault();
        if (!channel || !message)
            return;
        channel.sendMessage(message, { threadId: threadId });
        setMessage("");
    };
    return (react_1.default.createElement("form", { className: "chat-send-container", onSubmit: handleSubmit },
        react_1.default.createElement("input", { type: "text", onChange: handleChange, value: message }),
        react_1.default.createElement("button", { type: "submit" }, "Send")));
};
exports.default = ChatSend;
